import React, { useEffect, useState } from "react";
import backArrow from "../../../../assets/images/backArrow.svg";
import downloadIcon from "../../../../assets/images/downloadIcon.svg";
import blueTickIcon from "../../../../assets/images/blueTickIcon.svg";
import redCrossIcon from "../../../../assets/images/redCrossIcon.svg";
import copyIcon from "../../../../assets/images/copyIcon.svg";
import { Card, Modal, ModalBody } from "reactstrap";
import { generateAllInvoiceLogsXML, generateLogXML } from "../../../../helper/helperFunctions";
import toast from "react-hot-toast";
import moment from "moment";
function InvoicesLogsModal({ show, onHide, invoiceData, invoiceLogs, handleLoadMoreLogs, totalLogsCount }: any) {
  const language = localStorage.getItem("language");
  const [allLogs, setAllLogs] = useState<any>([]);

  useEffect(() => {
    let refactoredLogs = invoiceLogs?.map((item: any) => {
      return {
        ...item,
        status: item?.logMessage?.toLowerCase()?.includes("created")
          ? "Created"
          : item?.logMessage?.toLowerCase()?.includes("sync")
            ? "Synced"
            : item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
              ? "Failed"
              : "Success",
        title: item?.logMessage,
        isExpanded: false,
        details: [
          // { heading: "Time", description: item?.createdAt },
          { heading: "Time", description: item?.additionalInfo?.moreDetails?.formattedDate || item?.additionalInfo?.formattedDate },
          { heading: "Invoice ID", description: item?.additionalInfo?.invoiceName || item?.additionalInfo?.invoiceId },
          ...(item?.createdBy === "System"
            ? [
                {
                  heading: "Invoice UUID",
                  description: item?.additionalInfo?.invoiceUUID,
                },

                item?.logMessage?.includes("Submit") && {
                  heading: "Channel",
                  description: item?.additionalInfo?.channel,
                },

                item?.logMessage?.includes("Sign") && {
                  heading: "Certificate Type",
                  description: item?.additionalInfo?.envType,
                },

                item?.logMessage?.includes("Sign") && {
                  heading: "CSID",
                  description: item?.additionalInfo?.certificateId,
                },

                item?.logMessage?.includes("Validate") && {
                  heading: "Validation Result",
                  description: "Passed",
                },

                item?.logMessage?.includes("Validate") && {
                  heading: "XSD Version",
                  description: "ZATCA-UBL-2.1-v1.0",
                },
              ].filter(Boolean)
            : []),

          // { heading: "Invoice Reference", description: item?.additionalInfo?.moreDetails?.invoiceReference },
          ...(item?.additionalInfo?.moreDetails?.invoiceReference?.length > 0
            ? [{ heading: "Invoice Reference", description: item?.additionalInfo?.moreDetails?.invoiceReference }]
            : []),
          {
            heading: "POS ID",
            description: item?.additionalInfo?.moreDetails?.posId ? item?.additionalInfo?.moreDetails?.posId : item?.additionalInfo?.posId,
          },
          { heading: "Store ID", description: item?.additionalInfo?.moreDetails?.storeId || item?.additionalInfo?.storeId },
          {
            heading: "Actor",
            description: (
              <>
                {item?.createdBy === "System" ||
                item?.additionalInfo?.moreDetails?.initiatedBy === "system" ||
                item?.additionalInfo?.initiatedBy === "system" ? (
                  <div>System</div>
                ) : (
                  <>
                    {" "}
                    <div>ID: {item?.additionalInfo?.moreDetails?.actor?.id}</div>
                    <div>Name: {item?.additionalInfo?.moreDetails?.actor?.name}</div>
                  </>
                )}
              </>
            ),
          },
          ...(item?.logMessage?.includes("Sync")
            ? [
                {
                  heading: "Attempt No",
                  description: item?.additionalInfo?.moreDetails?.attemptNo || item?.additionalInfo?.attemptNo,
                },
              ]
            : []),
          ...(item?.logMessage?.includes("Submit") || item?.logMessage?.includes("Zatca Response")
            ? [
                {
                  heading: "Request ID",
                  description: item?.additionalInfo?.requestId,
                },
                {
                  heading: "Request Time",
                  description: item?.additionalInfo?.requestTime
                    ? moment(item?.additionalInfo?.requestTime).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")
                    : "",
                },
                {
                  heading: "Response ID",
                  description: item?.additionalInfo?.responseId,
                },
                {
                  heading: "Response Time",
                  description: item?.additionalInfo?.responseTime
                    ? moment(item?.additionalInfo?.responseTime).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")
                    : "",
                },
              ]
            : []),
          {
            heading: "Invoice Type",
            description: item?.additionalInfo?.moreDetails?.type || item?.additionalInfo?.type,
          },
          ...(item?.logMessage?.includes("Generate") || item?.logMessage?.includes("Validate")
            ? [
                {
                  heading: "XML Ref",
                  description: item?.additionalInfo?.xmlRef,
                },
              ]
            : []),
          ...(item?.logMessage?.includes("Generate")
            ? [
                {
                  heading: "XML Hash",
                  description: item?.additionalInfo?.xmlHash,
                },
              ]
            : []),
          {
            heading: "Status",
            description: (
              <span style={{ fontWeight: "700", color: "#404040" }}>
                {item?.logMessage?.toLowerCase()?.includes("created")
                  ? "Created"
                  : item?.logMessage?.toLowerCase()?.includes("sync")
                    ? "Synced"
                    : item?.additionalInfo?.response}
              </span>
            ),
          },
        ],
      };
    });
    setAllLogs([...refactoredLogs]);
  }, [invoiceLogs]);

  const handleExpandItem = (id: any) => {
    let refactoredData = allLogs?.map((item: any) => {
      return { ...item, isExpanded: id === item?._id ? !item?.isExpanded : false };
    });
    setAllLogs([...refactoredData]);
  };
  const handleDownloadAllLogs = () => {
    if (!invoiceLogs || invoiceLogs.length === 0) return;

    const xml = generateAllInvoiceLogsXML(allLogs);
    const blob = new Blob([xml], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15);

    const a = document.createElement("a");
    a.href = url;
    a.download = `pos_logs_${timestamp}.xml`;
    a.click();
    window.URL.revokeObjectURL(url);

    toast.success("XML generated successfully");
  };
  const handleDownloadLog = (log: any) => {
    let selectedInvoice = invoiceLogs?.find((item: any) => item._id === log._id);

    const xml = generateLogXML(selectedInvoice);
    const invoiceId = selectedInvoice?._id || "dummyInvoice";

    const blob = new Blob([xml], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15); // YYYYMMDDThhmm

    const a = document.createElement("a");
    a.href = url;
    a.download = `${invoiceId}_changelog_${timestamp}.xml`;
    a.click();
    toast.success("XML generated successfully");
  };
  return (
    <div className="invoice-modal">
      <Modal isOpen={show} onClosed={onHide} size="md" aria-labelledby="example-modal-sizes-title-lg" className="right-side-modal h-100">
        <div className="bg-white">
          <div className={`d-flex align-items-center p-4 ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
            <div
              onClick={() => {
                onHide();
              }}
              style={{ cursor: "pointer" }}
            >
              <img src={backArrow} alt="back" style={{ width: "8px" }} />
            </div>
            <div className="ml-auto mr-auto" style={{ color: "#333333", fontSize: "16px", fontWeight: 700 }}>
              Invoice <span>{invoiceData?.invoiceData?.invoiceNumber}</span> Log
            </div>

            <div style={{ cursor: "pointer" }} onClick={handleDownloadAllLogs}>
              <img src={downloadIcon} alt="back" />
            </div>
          </div>
        </div>

        <ModalBody className="overlay overlay-block cursor-default p-4" style={{ background: "#F2F2F2" }}>
          <div className={` ${language === "arabic" ? " text-right" : "text-left"}`}>
            <div>
              {allLogs?.map((item: any) => {
                return (
                  <>
                    <Card className="rounded mb-2 p-3" style={{ cursor: "pointer" }}>
                      <div>
                        {item?.isExpanded ? (
                          <div className="d-flex pb-4" style={{ gap: "1rem" }}>
                            <div className="position-relative relative">
                              {" "}
                              <img
                                src={
                                  item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
                                    ? redCrossIcon
                                    : blueTickIcon
                                }
                                alt="tick"
                              />
                              <div
                                className="vertical-line"
                                style={{ position: "absolute", width: "2px", background: "#DEE5E9", height: "94%", left: "7px", top: "1.8rem" }}
                              ></div>
                            </div>
                            <div className="w-100" style={{ fontSize: "16px", fontWeight: 400, marginTop: "-3px" }}>
                              <div className="w-100 d-flex justify-content-between">
                                <div style={{ color: "#236DD1" }} className="pb-2">
                                  {item?.title}
                                </div>
                                <div className="cursor-pointer" onClick={() => handleDownloadLog(item)}>
                                  <img src={copyIcon} alt="" />
                                </div>
                              </div>
                              {item?.details?.map((subItem: any) => {
                                return (
                                  <>
                                    <div onClick={() => handleExpandItem(item?._id)}>
                                      <div className="logs-small-text pt-1">{subItem?.heading}</div>
                                      <div className="logs-normal-text">{subItem?.description}</div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex pb-4" style={{ gap: "1rem", marginTop: "-3px" }} onClick={() => handleExpandItem(item?._id)}>
                            <div className="position-relative relative">
                              {" "}
                              <img
                                src={
                                  item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
                                    ? redCrossIcon
                                    : blueTickIcon
                                }
                                alt="tick"
                              />
                              <div
                                className="vertical-line"
                                style={{ position: "absolute", width: "2px", background: "#DEE5E9", height: "68%", left: "7px", top: "1.8rem" }}
                              ></div>
                            </div>
                            <div className="d-flex justify-content-between w-100">
                              <div style={{ fontSize: "16px", fontWeight: 400, marginTop: "-3px" }}>
                                <div style={{ color: "#236DD1" }} className="pb-2">
                                  {item?.title}
                                </div>
                                <div style={{ fontSize: "14px" }}>
                                  {item?.additionalInfo?.moreDetails?.formattedDate || item?.additionalInfo?.formattedDate}
                                </div>
                                <div style={{ fontSize: "14px" }}>{item?.createdBy}</div>
                              </div>
                              <div style={{ color: "#333333" }}>{item?.status}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Card>
                  </>
                );
              })}
              {Number(totalLogsCount) > Number(invoiceLogs?.length) ? (
                <div style={{ cursor: "pointer" }} onClick={handleLoadMoreLogs}>
                  Load More
                </div>
              ) : null}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default InvoicesLogsModal;
